// MIDAS V3 — the "verified" band inside a Variant E status-table card
// (MIDAS-VERIFIED-LINE-1, owner go 2026-10-10; bot P5-READER-VERIFIED-HEADER-1,
// machineid-bot-integration/MACHINEID_TODO.md:9-24).
// Spec: IMPLEMENTATION_TEMPLATES/ToDo/MidasChat/VERIFIED_LINE_SPEC.md §5.
//
// Rendered ONLY for the paragraph statusTableGrammar marked (it starts with
// <verified-line/> and sits directly above a DETECTED status table); every
// other paragraph keeps markdownComponentsV3's plain `p`. PLACEMENT (owner
// ruling 2026-10-11 "1b" = match Paper exactly): StatusTableFrameV3 draws it
// INSIDE that table's card, under the header bar; the paragraph's own position
// renders nothing. The caller (markdownComponentsV3's `table` renderer) has
// already stripped the marker; children = the sentence as text.
//
// Paper "MIDAS answer format — before / after", page "MIDAS pipeline", board
// "P5 — Verified reason lines: Today vs After P5", frame "Column After P5" →
// "MIDAS answer" → "Table" → node "Verified header line" (get_jsx /
// get_computed_styles):
//   icon frame 22×22 (flex-shrink 0, centred) holding an 18×18 SVG, viewBox
//   0 0 18 18: shield path fill #2F56A0 (= the text ink → currentColor) +
//   check path stroke #FFFFFF 1.7, round caps / joins, no fill.
// Band box / text values live in ./verified-line.css.
//
// Text run: Paper draws ONE uniform run (14/18 600) — no separately styled
// label, which also matches the owner rule (never key on the words).
//
// SEC-REQ-VL-3: the sentence reaches the band only as React text children via
// renderText (no innerHTML, no second markdown pass, no attribute / title /
// log copy). a11y: no role / aria-label on the <p> — the sentence itself is
// the accessible text; the icon is decorative. Nothing animates (the pulse is
// the live chip's signature — this must read differently).
// No MUI, no @emotion, no `sx`, no `dt` tokens. 3-tier via useBreakpoint:
// `--phone` takes the card's phone inline padding (verified-line.css).
import * as React from "react";

import { useBreakpoint } from "../../../../shared/hooks/useBreakpoint";

type RenderText = (children: React.ReactNode) => React.ReactNode;

export const VerifiedLineV3: React.FC<{
  renderText: RenderText;
  children?: React.ReactNode;
}> = ({ renderText, children }) => {
  const { isPhone } = useBreakpoint();
  return (
    <p className={isPhone ? "midas-vl midas-vl--phone" : "midas-vl"} data-verified-line="band">
      <svg
        className="midas-vl__icon"
        width={18}
        height={18}
        viewBox="0 0 18 18"
        aria-hidden="true"
        focusable="false"
      >
        {/* Paper: shield, fill #2F56A0 → currentColor (--verified-ink) */}
        <path
          d="M9 1.5l6 2.4v4.5c0 3.7-2.6 6.6-6 8.1-3.4-1.5-6-4.4-6-8.1V3.9l6-2.4z"
          fill="currentColor"
        />
        {/* Paper: check, stroke #FFFFFF 1.7, round caps + joins */}
        <path
          d="M6 9.1l2.1 2.1L12.2 7"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth={1.7}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="midas-vl__text">{renderText(children)}</span>
    </p>
  );
};
